import cn from 'classnames';
import { v4 as uuidv4 } from 'uuid';

import styles from './UserNotificationRow.module.scss';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from '../../../CorePackage/MainModule/constants/dateFormats';
import { INotificationRecord } from '../../../APIPackage/UserNotificationModule/interfaces/NotificationRecord';

interface IPointLineProps {
  notification: INotificationRecord;
  handleClick: (setIsUnreadToFalse?: boolean) => void;
}

export const UserNotificationRow = ({ notification, handleClick }: IPointLineProps) => {
  const { isUnread } = notification;
  let timeFieldClassName;
  let ellipseFieldClassName;
  let messageFieldClassName;

  if (isUnread) {
    timeFieldClassName = cn([styles.FiledTimeIsUnread]);
    ellipseFieldClassName = cn([styles.EllipseForIsUnread]);
    messageFieldClassName = cn([styles.FiledMessageIsUnread]);
  } else {
    timeFieldClassName = cn([styles.FiledTimeIsRead]);
    ellipseFieldClassName = cn([styles.EllipseForIsRead]);
    messageFieldClassName = cn([styles.FiledMessageIsRead]);
  }

  const hrefMatch = notification.message.match(/<a href=[^>]*>([\s\S]*?)<\/a>/g);

  return (
    <div className={styles.RowData} key={uuidv4()}>
      <div className={timeFieldClassName}>
        {formatDate({
          date: notification.createdAt,
          dateFormat: DATE_FORMAT_LONG_MINUTE_FNS,
          parseFormat: DATE_FORMAT_ISO_FNS,
        })}
      </div>
      <div className={ellipseFieldClassName} onClick={() => handleClick()} />

      {hrefMatch && (
        <div className={styles.MessageItems}>
          <div
            className={messageFieldClassName}
            onClick={() => handleClick(true)}
            /* eslint-disable-next-line react/no-danger */
            dangerouslySetInnerHTML={{ __html: notification.message }}
          />
        </div>
      )}
      {!hrefMatch && (
        /* eslint-disable-next-line react/no-danger */
        <div className={messageFieldClassName} dangerouslySetInnerHTML={{ __html: notification.message }}></div>
      )}
    </div>
  );
};
